import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AssistantWidget } from "./AssistantWidget";

// AI poradca je zatiaľ v zálohe — prepni na true, keď ho chceš spustiť.
const ASSISTANT_ENABLED = false;

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

export const Layout = () => (
  <div className="App relative bg-[#050505] text-white overflow-x-hidden min-h-screen">
    <div className="grain" />
    <ScrollManager />
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
    {ASSISTANT_ENABLED && <AssistantWidget />}
  </div>
);
